import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import IconPreview from "../../../components/BuilderComponents/Preview/IconPreview";
import Button from "../../../components/FormComponents/Button";
import Input from "../../../components/FormComponents/Input";
import { useScreenContext } from "../../../context/ScreenContext";
import HeaderLogoModal from "../Header/HeaderLogoModal";
import ScreenHeaderItem, { ScreenHeaderSubMenu } from "./ScreenHeaderItem";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getLogoUrl } from "../../../utils/screenutils";

const NewHeaderRenderer = ({ allPages, selectedModule, currentScreenData, selectedTab, selectedGroup }) => {
  const { setCurrentScreenData } = useScreenContext();
  const updateHeaderData = (key, data) => {
    // setHeaderConfig({ ...headerConfig, [key]: data });
    setCurrentScreenData((prev) => ({
      ...prev,
      header_config: {
        ...prev.header_config,
        [key]: data
      }
    }));
  };

  const updateModuleHeaderData = (data) => {
    setCurrentScreenData((prev) => ({
      ...prev,
      module_header_config: prev.module_header_config.map((mod) =>
        mod.id === selectedModule
          ? {
              ...mod,
              config: {
                ...mod.config,
                menu: selectedTab === "1" ? data : mod.config.menu,
                menu_bottom: selectedTab === "0" ? data : mod.config.menu_bottom
              }
            }
          : mod
      )
    }));
  };

  const headerClassName =
    currentScreenData.device === "mobile" && selectedTab === "1"
      ? "screen_header_outerbox header_create_block mobile_nav"
      : "screen_header_outerbox header_create_block";

  return (
    <div className={headerClassName}>
      <RenderHeaderLogo headerConfig={currentScreenData?.header_config} updateHeaderData={updateHeaderData} />
      {currentScreenData?.header_config?.show_app_name && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            fontWeight: "600",
            fontSize: "16px"
          }}
        >
          Application Name
        </div>
      )}
      <HeaderActions
        allPages={allPages}
        moduleHeaderConfig={currentScreenData.module_header_config || []}
        selectedModule={selectedModule}
        updateModuleHeaderData={updateModuleHeaderData}
        selectedTab={selectedTab}
        currentScreenData={currentScreenData}
        selectedGroup={selectedGroup}
        setCurrentScreenData={setCurrentScreenData}
        updateHeaderData={updateHeaderData}
      />
    </div>
  );
};

export default NewHeaderRenderer;

export const HeaderActions = ({
  allPages,
  moduleHeaderConfig,
  selectedModule,
  updateModuleHeaderData,
  selectedTab,
  currentScreenData,
  selectedGroup,
  setCurrentScreenData,
  updateHeaderData
}) => {
  const { header_config: headerConfig } = currentScreenData;
  const [menu, setMenu] = useState(selectedTab === "1" ? headerConfig.menu || [] : headerConfig.menu_bottom || []);

  useEffect(() => {
    if (selectedModule) {
      const selectedModuleConfig = moduleHeaderConfig.find((mod) => mod.id === selectedModule);
      if (selectedModuleConfig?.config) {
        setMenu(
          selectedTab === "1" ? selectedModuleConfig.config.menu || [] : selectedModuleConfig.config.menu_bottom || []
        );
      }
    } else {
      setMenu(selectedTab === "1" ? headerConfig.menu || [] : headerConfig.menu_bottom || []);
    }
  }, [headerConfig, selectedModule, moduleHeaderConfig, selectedTab]);

  let filteredMenu = menu;

  if (selectedGroup?.length > 0) {
    filteredMenu = menu.filter((menuItem) => menuItem.allowed_groups?.includes(selectedGroup));
  }

  const handleUpdateHeaderData = (data) => {
    if (selectedModule) {
      updateModuleHeaderData(data);
    } else {
      const updatedConfig = selectedTab === "1" ? { menu: data } : { menu_bottom: data };
      setCurrentScreenData((prev) => ({
        ...prev,
        header_config: {
          ...prev.header_config,
          ...updatedConfig
        }
      }));
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
      <ScreenHeaderMenu
        allPages={allPages}
        updateHeaderData={handleUpdateHeaderData}
        menu={filteredMenu}
        currentScreenData={currentScreenData}
        selectedTab={selectedTab}
      />
      {/* Dummy Profile Icon */}
      <div className="screen_profile_icon screen">
        <div className="screen_header_user">
          <MaterialIcon name="account_circle" style={{ fontSize: "32px" }} />
        </div>
      </div>
      <RenderHeaderRightLogo headerConfig={headerConfig} updateHeaderData={updateHeaderData} />
    </div>
  );
};

export const RenderHeaderRightLogo = ({ headerConfig, updateHeaderData }) => {
  const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);

  const handleLogoClick = () => {
    setIsLogoModalOpen(true);
  };

  const renderLogo = () => {
    const { logosrc, logotext, logotextweight, logotextsize, logotextcolor } = headerConfig.right_logo || {};

    if (logosrc?.length > 0) {
      return (
        <div className="header_logo" style={{ padding: "0px" }}>
          <img src={getLogoUrl(logosrc)} alt="Logo" style={{ height: "40px", width: "auto" }} />
          <ButtonActionIcon className="top_edit_del_icon" type="edit" onClick={handleLogoClick} />
        </div>
      );
    } else if (logotext?.length > 0) {
      return (
        <div className="header_logo" style={{ padding: "8px", background: "none" }}>
          <span
            style={{
              fontWeight: logotextweight,
              fontSize: `${logotextsize}px`,
              color: logotextcolor
            }}
          >
            {logotext}
          </span>
          <ButtonActionIcon className="top_edit_del_icon" type="edit" onClick={handleLogoClick} />
        </div>
      );
    } else {
      return (
        <div
          className="header_logo"
          onClick={handleLogoClick}
          style={{ width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <MaterialIcon name="image" style={{ fontSize: "24px", color: "var(--builder-light-text)" }} />
          <ButtonActionIcon className="top_edit_del_icon" type="add" onClick={handleLogoClick} />
        </div>
      );
    }
  };

  return (
    <>
      {renderLogo()}
      <BuilderModal isOpen={isLogoModalOpen} onClose={() => setIsLogoModalOpen(false)} modalName="Add Right Logo">
        <HeaderLogoModal
          saveHeaderLogodata={(data) => updateHeaderData("right_logo", data)}
          currentLogoData={headerConfig.right_logo || {}}
          onClose={() => setIsLogoModalOpen(false)}
        />
      </BuilderModal>
    </>
  );
};

export const ScreenHeaderMenu = ({
  allPages,
  updateHeaderData,
  menu,
  selectedModule,
  updateModuleHeaderData,
  currentScreenData,
  selectedTab
}) => {
  const deletePage = (index) => {
    const updatedMenu = [...menu];
    updatedMenu.splice(index, 1);

    selectedModule ? updateModuleHeaderData(updatedMenu) : updateHeaderData(updatedMenu);
  };

  const editPage = (index, selectedIcon) => {
    const updatedMenu = [...menu];
    const editedObject = { ...updatedMenu[index], icon: selectedIcon };
    updatedMenu[index] = editedObject;

    selectedModule ? updateModuleHeaderData(updatedMenu) : updateHeaderData(updatedMenu);
  };

  const sortMenu = (list) => {
    selectedModule ? updateModuleHeaderData(list) : updateHeaderData(list);
  };

  const addNewPage = (pages) => {
    const selectedPages = menu.map((menuItem) => allPages.find((page) => page.id === menuItem.page_id)).filter(Boolean);

    const newPages = pages.filter((newPage) => !selectedPages.some((selectedPage) => selectedPage.id === newPage.id));

    const updatedMenu = [
      ...menu,
      ...newPages.map((newPage) => ({
        page_id: newPage.id,
        display: newPage.name,
        type: newPage.type === "dropdown" ? "dropdown" : "page"
      }))
    ];
    selectedModule ? updateModuleHeaderData(updatedMenu) : updateHeaderData(updatedMenu);
  };

  // const deletePageInSubMenu = (menuIndex, subMenuIndex) => {
  //   let arr = JSON.parse(JSON.stringify(headerConfig));
  //   let carr = arr.menu[menuIndex].dropdown;
  //   carr.splice(subMenuIndex, 1);

  //   setHeaderConfig({ ...headerConfig, menu: arr.menu });
  // };

  // const editPageInSubMenu = () => {};
  const addSubMenu = (submenu) => {
    const selectedPages = submenu.pages.map((page) => allPages.find((ap) => ap.id === page.id)).filter(Boolean);

    const newSubmenu = {
      display: submenu.display,
      icon: submenu.icon || "",
      page_id: "",
      type: "dropdown",
      dropdown: [
        ...selectedPages.map((page) => ({
          page_id: page.id,
          display: page.name,
          icon: page.icon || "",
          type: "page"
        })),
        ...(submenu.subDropdowns || [])
      ]
    };

    // Check if a module is selected
    if (selectedModule) {
      const updatedModuleMenu = [...menu, newSubmenu];
      updateModuleHeaderData(updatedModuleMenu);
    } else {
      const updatedMenu = [...menu, newSubmenu];
      updateHeaderData(updatedMenu);
    }
  };

  const handleSubMenuAction = (actionType, payload) => {
    let updatedMenu;

    switch (actionType) {
      case "edit_sub_menu":
        updatedMenu = menu.map((item, idx) => {
          if (idx === payload.index && item.type === "dropdown") {
            return {
              ...item,
              display: payload.submenu.display,
              dropdown: payload.submenu.dropdown
            };
          }
          return item;
        });
        break;
      case "update_sub_menu":
        updatedMenu = menu.map((item) => {
          if (item.type === "dropdown" && item.display === payload.submenu.display) {
            return {
              ...item,
              display: payload.submenu.display,
              dropdown: payload.submenu.dropdown
            };
          }
          return item;
        });
        break;
      default:
        console.warn("Unhandled actionType:", actionType);
        return;
    }

    updateHeaderData(updatedMenu);
  };

  const callBackAction = (action, payload) => {
    if (action === "delete_page") {
      deletePage(payload.index);
    } else if (action === "edit_page") {
      editPage(payload.index, payload.icon);
    } else if (action === "add_pages") {
      addNewPage(payload.pages);
    } else if (action === "sort_menu") {
      sortMenu(payload.list);
    } else if (action === "delete_sub_page") {
      // deletePageInSubMenu(payload.index);
    } else if (action === "edit_sub_menu") {
      handleSubMenuAction("edit_sub_menu", payload);
    } else if (action === "update_sub_menu") {
      handleSubMenuAction("update_sub_menu", payload);
    } else if (action === "add_sub_page") {
      addSubMenu(payload.submenu);
    }
  };

  const screenHeaderClassName =
    currentScreenData.device === "mobile" && selectedTab === "1" ? "" : "flex_row_justify_between_align_center ml_auto";

  return (
    <div className={`add-header-menu-wrap ${screenHeaderClassName}`}>
      <RenderScreenHeaderItems
        callBackAction={callBackAction}
        menu={menu}
        allPages={allPages}
        // deletePageInSubMenu={deletePageInSubMenu}
        // openSubMenuIndex={openSubMenuIndex}
        // handlePageClick={handlePageClick}
        // isEditable={isEditable}
        // setIsSubModalOpen={setIsSubModalOpen}
      />
      <MenuAction allPages={allPages} callBackAction={callBackAction} menu={menu} selectedTab={selectedTab} />
    </div>
  );
};

const RenderScreenHeaderItems = ({
  callBackAction,
  menu,
  allPages
  // deletePageInSubMenu,
  // openSubMenuIndex,
  // setIsSubModalOpen
}) => {
  const [openEditIndex, setOpenEditIndex] = useState(null);
  // console.log(menu);

  return (
    //   <div className={`screen_header_options ${headerConfig.style.nav_position}`} style={{ marginBottom: "14px" }}>
    <>
      <ReactSortable
        list={menu}
        setList={(newlist) => callBackAction("sort_menu", { list: newlist })}
        ghostClass="headerDragNDrop_dropArea"
        handle=".headerDragNDrop_dragHandle"
        filter=".ignoreDrag"
        preventOnFilter={true}
        className="screen_header_options add_headers"
      >
        {menu.map((page, index) =>
          page.type === "page" ? (
            <ScreenHeaderItem
              key={page.display + index}
              page={page}
              index={index}
              callBackAction={callBackAction}
              openEditIndex={openEditIndex}
              setOpenEditIndex={setOpenEditIndex}
            />
          ) : (
            <ScreenHeaderSubMenu
              key={page.display + index}
              page={page}
              index={index}
              callBackAction={callBackAction}
              allPages={allPages}
              menu={menu}
              openEditIndex={openEditIndex}
              setOpenEditIndex={setOpenEditIndex}
            />
          )
        )}
      </ReactSortable>
    </>
  );
};

export const MenuAction = ({ callBackAction, menu, allPages, selectedTab }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        size="small"
        className="font_size_large pr_1 pl_1 pt_0 pb_0"
        style={{ height: "32px", width: "40px", fontSize: "20px" }}
        onClick={() => setIsModalOpen(true)}
      >
        +
      </Button>
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName={"Add Pages"}>
        <AddPageModal
          allPages={allPages}
          menu={menu}
          callbackFunction={callBackAction}
          setIsModalOpen={setIsModalOpen}
          selectedTab={selectedTab}
        />
      </BuilderModal>
    </>
  );
};

export const RenderHeaderLogo = ({ headerConfig, updateHeaderData }) => {
  const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);

  const handleLogoClick = () => {
    setIsLogoModalOpen(true);
  };

  const renderLogo = () => {
    const { logosrc, logotext, logotextweight, logotextsize, logotextcolor } = headerConfig.logo;

    if (logosrc?.length !== 0) {
      return (
        <div className="header_logo" style={{ padding: "0px" }}>
          <img src={getLogoUrl(logosrc)} alt="Logo" style={{ height: "40px", width: "auto" }} />
          <ButtonActionIcon className="top_edit_del_icon" type="edit" onClick={handleLogoClick} />
        </div>
      );
    } else if (logotext?.length !== 0) {
      return (
        <div className="header_logo" style={{ padding: "8px", background: "none" }}>
          <span
            style={{
              fontWeight: logotextweight,
              fontSize: `${logotextsize}px`,
              color: logotextcolor
            }}
          >
            {logotext}
          </span>
          <ButtonActionIcon className="top_edit_del_icon" type="edit" onClick={handleLogoClick} />
        </div>
      );
    } else {
      return (
        <div
          className={`header_logo ${headerConfig.style.nav_position === "left" ? "left_vertical" : ""}`}
          onClick={handleLogoClick}
        >
          <span style={{ fontSize: "14px" }}>Add Logo</span>
          <ButtonActionIcon className="top_edit_del_icon" type="add" onClick={handleLogoClick} />
        </div>
      );
    }
  };

  return (
    <>
      {renderLogo()}
      <BuilderModal isOpen={isLogoModalOpen} onClose={() => setIsLogoModalOpen(false)} modalName="Add Logo">
        <HeaderLogoModal
          saveHeaderLogodata={(data) => updateHeaderData("logo", data)}
          currentLogoData={headerConfig.logo}
          onClose={() => setIsLogoModalOpen(false)}
        />
      </BuilderModal>
    </>
  );
};

const CollapsibleSubDropdown = ({ subDropdown, onRemove }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      style={{
        border: "1px solid var(--builder-border)",
        borderRadius: "4px",
        marginBottom: "4px"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px",
          cursor: "pointer"
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <MaterialIcon name={isExpanded ? "expand_less" : "expand_more"} style={{ fontSize: "18px" }} />
          <span style={{ fontSize: "12px", fontWeight: "500" }}>
            {subDropdown.display} ({subDropdown.dropdown?.length || 0} items)
          </span>
        </div>
        <MaterialIcon
          name="close"
          style={{ fontSize: "16px", cursor: "pointer", color: "var(--builder-light-text)" }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        />
      </div>
      {isExpanded && subDropdown.dropdown?.length > 0 && (
        <div style={{ padding: "0 8px 8px 32px", borderTop: "1px solid var(--builder-border)" }}>
          {subDropdown.dropdown.map((item, i) => (
            <div
              key={i}
              style={{
                fontSize: "12px",
                padding: "6px 0",
                color: "var(--builder-light-text)",
                borderBottom: i < subDropdown.dropdown.length - 1 ? "1px solid var(--builder-border)" : "none"
              }}
            >
              {item.display}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const AddPageModal = ({ allPages, menu, callbackFunction, setIsModalOpen, selectedTab }) => {
  const [isSubmenu, setIsSubmenu] = useState(false);
  const [submenuName, setSubmenuName] = useState("");
  const [selectedSubmenuPages, setSelectedSubmenuPages] = useState([]);
  const [selectedPages, setSelectedPages] = useState([]);
  const [subDropdowns, setSubDropdowns] = useState([]);
  const [isAddingSubDropdown, setIsAddingSubDropdown] = useState(false);
  const [newSubDropdownName, setNewSubDropdownName] = useState("");
  const [newSubDropdownPages, setNewSubDropdownPages] = useState([]);

  useEffect(() => {
    const initialSelectedPages = allPages.filter((page) => menu.some((menuItem) => menuItem.page_id === page.id));
    setSelectedPages(initialSelectedPages);
  }, [allPages, menu]);

  const handlePageSelect = (page) => {
    if (isSubmenu) {
      setSelectedSubmenuPages((prev) =>
        prev.some((p) => p.id === page.id) ? prev.filter((p) => p.id !== page.id) : [...prev, page]
      );
    } else {
      setSelectedPages((prev) =>
        prev.some((p) => p.id === page.id) ? prev.filter((p) => p.id !== page.id) : [...prev, page]
      );
    }
  };

  const handleAddSubDropdown = () => {
    if (newSubDropdownName.trim() && newSubDropdownPages.length > 0) {
      const newSubDropdown = {
        display: newSubDropdownName,
        icon: "",
        page_id: "",
        type: "dropdown",
        allowed_groups: null,
        dropdown: newSubDropdownPages.map((p) => ({
          display: p.name,
          page_id: p.id,
          icon: "",
          type: "page",
          allowed_groups: null
        }))
      };
      setSubDropdowns((prev) => [...prev, newSubDropdown]);
      setNewSubDropdownName("");
      setNewSubDropdownPages([]);
      setIsAddingSubDropdown(false);
    }
  };

  const handleSubDropdownPageToggle = (page) => {
    setNewSubDropdownPages((prev) =>
      prev.some((p) => p.id === page.id) ? prev.filter((p) => p.id !== page.id) : [...prev, page]
    );
  };

  const addSubmenu = () => {
    if (submenuName.trim() && (selectedSubmenuPages.length > 0 || subDropdowns.length > 0)) {
      callbackFunction("add_sub_page", {
        submenu: {
          display: submenuName,
          pages: selectedSubmenuPages,
          subDropdowns: subDropdowns
        }
      });
      setSubmenuName("");
      setSelectedSubmenuPages([]);
      setSubDropdowns([]);
      setIsSubmenu(false);
      setIsModalOpen(false);
    }
  };

  const savePages = () => {
    if (selectedPages.length > 0) {
      callbackFunction("add_pages", { pages: selectedPages });
    }
    setSelectedPages([]);
    setIsModalOpen(false);
  };

  return (
    <div style={{ overflow: "none", height: "100%", position: "relative" }}>
      <div>
        {selectedTab !== "0" && (
          <div className="d_flex justify_end">
            <Input type="checkbox" label="Add Submenu" checked={isSubmenu} onChange={() => setIsSubmenu(!isSubmenu)} />
          </div>
        )}
        {isSubmenu && (
          <div className="mb_2 mt_3 d_flex gap_3">
            <Input
              type="text"
              placeholder="Enter submenu name"
              value={submenuName}
              onChange={(e) => setSubmenuName(e.target.value)}
              style={{ marginRight: "8px" }}
            />
            <Button onClick={addSubmenu}>Add</Button>
          </div>
        )}
        {allPages
          .filter((page) => page.name && page.name !== "header")
          .map((page, index) => {
            const isSelected = isSubmenu
              ? selectedSubmenuPages.some((p) => p.id === page.id)
              : selectedPages.some((p) => p.id === page.id);

            return (
              <div
                key={index}
                style={{
                  padding: "8px 4px",
                  color: "var(--builder-font-color)",
                  cursor: "pointer",
                  display: "flex",
                  gap: "12px"
                }}
              >
                <Input
                  type="checkbox"
                  id={`page_${page.id}`}
                  checked={isSelected}
                  onChange={() => handlePageSelect(page)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor={`page_${page.id}`}
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    textDecoration: isSelected ? "" : "none"
                  }}
                >
                  {page.name}
                </label>
              </div>
            );
          })}

        {isSubmenu && (
          <>
            {subDropdowns.length > 0 && (
              <div style={{ marginTop: "12px", borderTop: "1px solid var(--builder-border)", paddingTop: "12px" }}>
                <div style={{ fontSize: "12px", fontWeight: "500", marginBottom: "8px" }}>Sub-dropdowns</div>
                {subDropdowns.map((sd, idx) => (
                  <CollapsibleSubDropdown
                    key={idx}
                    subDropdown={sd}
                    onRemove={() => setSubDropdowns((prev) => prev.filter((_, i) => i !== idx))}
                  />
                ))}
              </div>
            )}

            <div style={{ marginTop: "12px", borderTop: "1px solid var(--builder-border)", paddingTop: "12px" }}>
              {!isAddingSubDropdown ? (
                <Button
                  variant="secondary"
                  size="small"
                  onClick={() => setIsAddingSubDropdown(true)}
                  style={{ fontSize: "12px" }}
                >
                  + Add Sub-dropdown
                </Button>
              ) : (
                <div>
                  <Input
                    type="text"
                    placeholder="Sub-dropdown name"
                    value={newSubDropdownName}
                    onChange={(e) => setNewSubDropdownName(e.target.value)}
                  />
                  <div style={{ maxHeight: "150px", overflow: "auto", marginTop: "8px" }}>
                    {allPages
                      .filter((page) => page.name && page.name !== "header")
                      .map((page) => (
                        <div
                          key={page.id}
                          style={{ padding: "4px", display: "flex", gap: "8px", alignItems: "center" }}
                        >
                          <Input
                            type="checkbox"
                            checked={newSubDropdownPages.some((p) => p.id === page.id)}
                            onChange={() => handleSubDropdownPageToggle(page)}
                          />
                          <label style={{ fontSize: "12px", cursor: "pointer" }}>{page.name}</label>
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                    <Button size="small" onClick={handleAddSubDropdown}>
                      Add
                    </Button>
                    <Button
                      variant="secondary"
                      size="small"
                      onClick={() => {
                        setIsAddingSubDropdown(false);
                        setNewSubDropdownName("");
                        setNewSubDropdownPages([]);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {!isSubmenu && (
          <Button onClick={savePages} style={{ marginTop: "16px" }}>
            Save
          </Button>
        )}
      </div>
    </div>
  );
};

export const EditSubMenuModal = ({ allPages, submenuName, existingPages, callbackFunction }) => {
  const [newSubmenuName, setNewSubmenuName] = useState(submenuName);
  const [pages, setPages] = useState([]);
  const [subDropdowns, setSubDropdowns] = useState([]);
  const [isAddingSubDropdown, setIsAddingSubDropdown] = useState(false);
  const [newSubDropdownName, setNewSubDropdownName] = useState("");
  const [newSubDropdownPages, setNewSubDropdownPages] = useState([]);

  useEffect(() => {
    const pageItems = [];
    const dropdownItems = [];

    (existingPages || []).forEach((item) => {
      if (item.type === "dropdown" && item.dropdown?.length > 0) {
        dropdownItems.push(item);
      } else {
        pageItems.push(item);
      }
    });

    setPages(pageItems);
    setSubDropdowns(dropdownItems);
  }, [existingPages]);

  const handlePageChange = (pageId, isSelected) => {
    const selectedPage = allPages.find((page) => page.id === pageId);

    if (selectedPage) {
      if (isSelected) {
        if (!pages.some((page) => page.page_id === pageId)) {
          setPages((prevPages) => [
            ...prevPages,
            {
              display: selectedPage.name,
              page_id: selectedPage.id,
              type: ""
            }
          ]);
        }
      } else {
        setPages((prevPages) => prevPages.filter((page) => page.page_id !== pageId));
      }
    }
  };

  const handleAddSubDropdown = () => {
    if (newSubDropdownName.trim() && newSubDropdownPages.length > 0) {
      const newSubDropdown = {
        display: newSubDropdownName,
        icon: "",
        page_id: "",
        type: "dropdown",
        allowed_groups: null,
        dropdown: newSubDropdownPages.map((p) => ({
          display: p.name,
          page_id: p.id,
          icon: "",
          type: "page",
          allowed_groups: null
        }))
      };
      setSubDropdowns((prev) => [...prev, newSubDropdown]);
      setNewSubDropdownName("");
      setNewSubDropdownPages([]);
      setIsAddingSubDropdown(false);
    }
  };

  const handleRemoveSubDropdown = (idx) => {
    setSubDropdowns((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleSubDropdownPageToggle = (page) => {
    setNewSubDropdownPages((prev) =>
      prev.some((p) => p.id === page.id) ? prev.filter((p) => p.id !== page.id) : [...prev, page]
    );
  };

  const saveChanges = () => {
    callbackFunction({
      display: newSubmenuName,
      dropdown: [...pages, ...subDropdowns]
    });
  };

  return (
    <div style={{ overflow: "none", height: "100%", position: "relative" }}>
      <div>
        <Input type="text" value={newSubmenuName} onChange={(e) => setNewSubmenuName(e.target.value)} />
      </div>
      <div>
        {allPages
          .filter((page) => page.name !== "header")
          .map((page) => (
            <div
              style={{
                padding: "8px 4px",
                color: "var(--builder-font-color)",
                cursor: "pointer",
                display: "flex",
                gap: "12px"
              }}
              key={page.id}
            >
              <Input
                type="checkbox"
                checked={pages.some((p) => p.page_id === page.id)}
                onChange={(e) => handlePageChange(page.id, e.target.checked)}
              />
              <label
                htmlFor={`page_${page.id}`}
                style={{
                  fontSize: "12px",
                  cursor: "pointer"
                }}
              >
                {page.name}
              </label>
            </div>
          ))}

        {subDropdowns.length > 0 && (
          <div style={{ marginTop: "12px", borderTop: "1px solid var(--builder-border)", paddingTop: "12px" }}>
            <div style={{ fontSize: "12px", fontWeight: "500", marginBottom: "8px" }}>Sub-dropdowns</div>
            {subDropdowns.map((sd, idx) => (
              <CollapsibleSubDropdown key={idx} subDropdown={sd} onRemove={() => handleRemoveSubDropdown(idx)} />
            ))}
          </div>
        )}

        <div style={{ marginTop: "12px", borderTop: "1px solid var(--builder-border)", paddingTop: "12px" }}>
          {!isAddingSubDropdown ? (
            <Button
              variant="secondary"
              size="small"
              onClick={() => setIsAddingSubDropdown(true)}
              style={{ fontSize: "12px" }}
            >
              + Add Sub-dropdown
            </Button>
          ) : (
            <div>
              <Input
                type="text"
                placeholder="Sub-dropdown name"
                value={newSubDropdownName}
                onChange={(e) => setNewSubDropdownName(e.target.value)}
              />
              <div style={{ maxHeight: "150px", overflow: "auto", marginTop: "8px" }}>
                {allPages
                  .filter((page) => page.name !== "header")
                  .map((page) => (
                    <div key={page.id} style={{ padding: "4px", display: "flex", gap: "8px", alignItems: "center" }}>
                      <Input
                        type="checkbox"
                        checked={newSubDropdownPages.some((p) => p.id === page.id)}
                        onChange={() => handleSubDropdownPageToggle(page)}
                      />
                      <label style={{ fontSize: "12px", cursor: "pointer" }}>{page.name}</label>
                    </div>
                  ))}
              </div>
              <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                <Button size="small" onClick={handleAddSubDropdown}>
                  Add
                </Button>
                <Button
                  variant="secondary"
                  size="small"
                  onClick={() => {
                    setIsAddingSubDropdown(false);
                    setNewSubDropdownName("");
                    setNewSubDropdownPages([]);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>

        <Button onClick={saveChanges} style={{ marginTop: "16px" }}>
          Save
        </Button>
      </div>
    </div>
  );
};

const isAnyChildActive = (items, targetId) => {
  if (!items) return false;
  return items.some(
    (item) => item.page_id === targetId || (item.type === "dropdown" && isAnyChildActive(item.dropdown, targetId))
  );
};

const PreviewNestedItems = ({ items, screenId, handleItemClick }) => {
  const [openNested, setOpenNested] = useState(new Set());

  const toggleNested = (idx) => {
    setOpenNested((prev) => {
      const updated = new Set(prev);
      updated.has(idx) ? updated.delete(idx) : updated.add(idx);
      return updated;
    });
  };

  return items.map((subItem, subIndex) => {
    const isNestedDropdown = subItem.type === "dropdown" && subItem.dropdown?.length > 0;

    if (isNestedDropdown) {
      const isNestedActive = isAnyChildActive(subItem.dropdown, screenId);
      return (
        <div key={subIndex} className={`pagelist_item nested_preview_dropdown ${isNestedActive ? "active" : ""}`}>
          <div
            className="d_flex align_center justify_between"
            onClick={(e) => {
              e.stopPropagation();
              toggleNested(subIndex);
            }}
            style={{ cursor: "pointer", width: "100%" }}
          >
            <span>{subItem.display}</span>
            <MaterialIcon
              name={openNested.has(subIndex) ? "expand_less" : "expand_more"}
              style={{ fontSize: "16px" }}
            />
          </div>
          {openNested.has(subIndex) && (
            <div className="pagelist_item_sub_submenu screen_header_item">
              <PreviewNestedItems items={subItem.dropdown} screenId={screenId} handleItemClick={handleItemClick} />
            </div>
          )}
        </div>
      );
    }

    return (
      <div
        key={subIndex}
        className={`pagelist_item ${subItem.page_id === screenId ? "active" : ""}`}
        onClick={() => handleItemClick(subItem.page_id)}
      >
        <span>{subItem.display}</span>
      </div>
    );
  });
};

export const MenuPerview = ({ headerConfig }) => {
  const [menu, setMenu] = useState(headerConfig.menu || []);
  const [isOpen, setIsOpen] = useState(new Set());
  const { currentScreenData, selectedScreen } = useScreenContext();
  const navigate = useNavigate();
  const { screenId } = useParams();

  // Update menu when headerConfig changes
  useEffect(() => {
    setMenu(headerConfig.menu || []);
  }, [headerConfig]);

  // Toggle dropdown open/close
  const toggleDropdown = (index) => {
    setIsOpen((prev) => {
      const updated = new Set(prev);
      updated.has(index) ? updated.delete(index) : updated.add(index);
      return updated;
    });
  };

  // Navigate to a page on click
  const handleItemClick = (pageId) => {
    if (pageId && selectedScreen.type !== "header") {
      navigate(`../${pageId}`);
    }
  };

  // Menu item component
  const MenuItem = ({ page, index }) => {
    const isActive = page.type === "page" && screenId === page.page_id;
    const isSubmenuItemActive = isAnyChildActive(page.dropdown, screenId);
    const isDropdown = page.type === "dropdown";

    const handleClick = () => {
      if (isDropdown) {
        toggleDropdown(index);
      } else {
        handleItemClick(page.page_id);
      }
    };

    return (
      <div key={index} className="pagelist_item headerDragNDrop_dragHandle">
        <div
          className={`d_flex align_center ${isDropdown ? "z-subMenu" : ""} ${isSubmenuItemActive ? "screen_header_item active" : ""}`}
        >
          <div className={`header_menu_item screen_header_item ${isActive ? "active" : ""}`} onClick={handleClick}>
            {page.icon && <IconPreview icon={page.icon || ""} />}
            <span>{page.display}</span>
          </div>
          {isDropdown && (
            <>
              <div className="header_submenu">
                <MaterialIcon
                  name={isOpen.has(index) ? "expand_less" : "expand_more"}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleDropdown(index);
                  }}
                  style={{ fontSize: "20px" }}
                />
              </div>
              {isOpen.has(index) && (
                <div className="header_submenu">
                  <div className="pagelist_item_submenu screen_header_item">
                    <PreviewNestedItems items={page.dropdown} screenId={screenId} handleItemClick={handleItemClick} />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
  const isDesktop = currentScreenData.device === "desktop" || currentScreenData.device === "tablet";
  return (
    <>
      {currentScreenData.device === "mobile" && (
        <div style={{ cursor: "move" }}>
          <div className="p_0">{renderLogo(headerConfig)}</div>
        </div>
      )}
      <div className={isDesktop ? "screen_header_options " : "mobile-nav-items-outer"}>
        {menu.map((item, index) => (
          <MenuItem key={index} page={item} index={index} />
        ))}
      </div>
    </>
  );
};

export const renderLogo = (headerConfig) => {
  const { logosrc, logotext, logotextweight, logotextsize, logotextcolor } = headerConfig.logo;
  if (logosrc?.length !== 0) {
    return (
      <div style={{ paddingLeft: "14px" }}>
        <img src={getLogoUrl(logosrc)} alt="Logo" style={{ height: "40px", width: "auto" }} />
      </div>
    );
  } else if (logotext?.length !== 0) {
    return (
      <div style={{ padding: "8px", background: "none" }}>
        <span
          style={{
            fontWeight: logotextweight,
            fontSize: `${logotextsize}px`,
            color: logotextcolor
          }}
        >
          {logotext}
        </span>
      </div>
    );
  } else {
    return null;
  }
};
